// src/pages/Profile.js
import React, { useEffect, useState } from 'react';
import { Container, Card, Form, Button, Alert, Row, Col, Spinner } from 'react-bootstrap';
import api from '../services/api';

const Profile = () => {
    const [profile, setProfile] = useState(null);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [formData, setFormData] = useState({
        first_name: '',
        last_name: '',
        bio: '',
        website: '',
        expertise: '',
    });
    const [passwordData, setPasswordData] = useState({
    old_password: '',
    new_password: '',
    new_password2: '',
    });
    const [passwordSaving, setPasswordSaving] = useState(false);
    const [passwordError, setPasswordError] = useState('');
    const [passwordSuccess, setPasswordSuccess] = useState('');

    useEffect(() => {
        fetchProfile();
    }, []);
    const handlePasswordChangeInput = (e) => {
        setPasswordData({
            ...passwordData,
            [e.target.name]: e.target.value,
        });
    };

    const handlePasswordChange = async (e) => {
        e.preventDefault();
        setPasswordSaving(true);
        setPasswordError('');
        setPasswordSuccess('');

        try {
            await api.post('/users/change_password/', passwordData);
            setPasswordSuccess('Hasło zostało zmienione pomyślnie!');
            setPasswordData({
                old_password: '',
                new_password: '',
                new_password2: '',
            });
        } catch (err) {
            if (err.response?.data) {
                const errors = err.response.data;
                if (errors.old_password) {
                    setPasswordError(errors.old_password[0]);
                } else if (errors.new_password) {
                    setPasswordError(errors.new_password[0]);
                } else {
                    setPasswordError('Błąd podczas zmiany hasła');
                }
            } else {
                setPasswordError('Błąd połączenia z serwerem');
            }
        } finally {
            setPasswordSaving(false);
        }
    };
    const fetchProfile = async () => {
        try {
            const response = await api.get('/users/me/');
            setProfile(response.data);
            setFormData({
                first_name: response.data.first_name || '',
                last_name: response.data.last_name || '',
                bio: response.data.bio || '',
                website: response.data.website || '',
                expertise: response.data.expertise || '',
            });
        } catch (err) {
            setError('Nie udało się pobrać danych profilu');
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSaving(true);
        setError('');
        setSuccess('');

        try {
            const response = await api.patch('/users/me/', formData);
            setProfile(response.data);
            setSuccess('Profil zaktualizowany pomyślnie!');
        } catch (err) {
            setError('Błąd podczas zapisywania profilu');
            console.error(err);
        } finally {
            setSaving(false);
        }
    };

    if (loading) {
        return (
            <Container className="text-center mt-5">
                <Spinner animation="border" variant="primary" />
                <p className="mt-3">Ładowanie profilu...</p>
            </Container>
        );
    }

    return (
        <Container className="mt-4">
            <Row>
                <Col md={8} className="mx-auto">
                    <Card className="shadow-sm">
                        <Card.Body>
                            <h2 className="mb-4">👤 Mój profil</h2>

                            {error && <Alert variant="danger">{error}</Alert>}
                            {success && <Alert variant="success">{success}</Alert>}

                            <Form onSubmit={handleSubmit}>
                                <Row>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Imię</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="first_name"
                                                value={formData.first_name}
                                                onChange={handleChange}
                                                placeholder="Twoje imię"
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Nazwisko</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="last_name"
                                                value={formData.last_name}
                                                onChange={handleChange}
                                                placeholder="Twoje nazwisko"
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Form.Group className="mb-3">
                                    <Form.Label>Nazwa użytkownika</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={profile?.username || ''}
                                        disabled
                                        className="bg-light"
                                    />
                                    <Form.Text className="text-muted">
                                        Nazwy użytkownika nie można zmienić
                                    </Form.Text>
                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label>Email</Form.Label>
                                    <Form.Control
                                        type="email"
                                        value={profile?.email || ''}
                                        disabled
                                        className="bg-light"
                                    />
                                    <Form.Text className="text-muted">
                                        Adres email nie może być zmieniony
                                    </Form.Text>
                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label>Rola</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={profile?.role_display || profile?.role || ''}
                                        disabled
                                        className="bg-light"
                                    />
                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label>Bio</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={3}
                                        name="bio"
                                        value={formData.bio}
                                        onChange={handleChange}
                                        placeholder="Krótko o sobie..."
                                    />
                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label>Strona internetowa</Form.Label>
                                    <Form.Control
                                        type="url"
                                        name="website"
                                        value={formData.website}
                                        onChange={handleChange}
                                        placeholder="https://twojastrona.pl"
                                    />
                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label>Ekspertyza / Specjalizacja</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="expertise"
                                        value={formData.expertise}
                                        onChange={handleChange}
                                        placeholder="np. Python, Django, React"
                                    />
                                </Form.Group>

                                <div className="d-flex gap-2">
                                    <Button variant="primary" type="submit" disabled={saving}>
                                        {saving ? 'Zapisywanie...' : '💾 Zapisz profil'}
                                    </Button>
                                </div>
                            </Form>
                            <hr className="my-4" />
                            <h4 className="mb-3">🔑 Zmień hasło</h4>
                            {passwordError && <Alert variant="danger">{passwordError}</Alert>}
                            {passwordSuccess && <Alert variant="success">{passwordSuccess}</Alert>}
                            <Form onSubmit={handlePasswordChange}>
                                <Row>
                                    <Col md={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Stare hasło</Form.Label>
                                            <Form.Control
                                                type="password"
                                                name="old_password"
                                                value={passwordData.old_password}
                                                onChange={handlePasswordChangeInput}
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Nowe hasło</Form.Label>
                                            <Form.Control
                                                type="password"
                                                name="new_password"
                                                value={passwordData.new_password}
                                                onChange={handlePasswordChangeInput}
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Powtórz hasło</Form.Label>
                                            <Form.Control
                                                type="password"
                                                name="new_password2"
                                                value={passwordData.new_password2}
                                                onChange={handlePasswordChangeInput}
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <div className="d-flex gap-2">
                                    <Button 
                                        variant="outline-warning" 
                                        type="submit" 
                                        disabled={passwordSaving}
                                    >
                                        {passwordSaving ? 'Zmienianie...' : '🔑 Zmień hasło'}
                                    </Button>
                                </div>
                            </Form>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default Profile;